var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "flex mb-4 justify-end items-center p-3" },
      [
        _c("span", { staticClass: "mr-3" }, [_vm._v("Filter Date:")]),
        _vm._v(" "),
        _c("date-range-picker", {
          ref: "picker",
          attrs: {
            timePicker: false,
            showDropdowns: false,
            "max-date": _vm.maxDate,
            opens: "left",
            "auto-apply": true
          },
          on: { update: _vm.onChangeDate },
          scopedSlots: _vm._u([
            {
              key: "input",
              fn: function(picker) {
                return [
                  _vm._v(
                    "\n            From: " +
                      _vm._s(_vm.moment(picker.startDate)) +
                      " - To: " +
                      _vm._s(_vm.moment(picker.endDate)) +
                      "\n          "
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.dateRange,
            callback: function($$v) {
              _vm.dateRange = $$v
            },
            expression: "dateRange"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "flex flex-wrap" }, [
      _c("div", { staticClass: "w-1/4 md:w-1/3 p-3" }, [
        _c("div", { staticClass: "mb-2 bg-white" }, [
          _c(
            "div",
            {
              staticClass:
                "card cursor-pointer border border-gray-400 rounded-lg hover:shadow-md hover:border-opacity-0 transform hover:-translate-y-1 transition-all duration-200"
            },
            [
              _c("div", { staticClass: "m-3" }, [
                _c(
                  "h2",
                  {
                    staticClass:
                      "text-xs text-left font-bold mb-2 border-b border-black mb-3"
                  },
                  [_vm._v("Top Subscriber Country")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "h-300 overflow-y-auto" }, [
                  _c(
                    "ol",
                    {
                      staticClass: "list-outside pl-6",
                      class:
                        _vm.dataTopSubscriberCountry.length > 0
                          ? "list-decimal"
                          : ""
                    },
                    [
                      _vm.dataTopSubscriberCountry.length === 0
                        ? _c(
                            "li",
                            {
                              staticClass:
                                "text-center text-sm font-bold text-black p-3"
                            },
                            [_vm._v("No Data")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.dataTopSubscriberCountry, function(country) {
                        return _c(
                          "li",
                          {
                            key: country.name,
                            staticClass:
                              "text-left text-sm font-bold text-black mb-3"
                          },
                          [
                            _vm._v(
                              "\n                      " + _vm._s(country.name)
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "text-xs text-teal-800 float-right"
                              },
                              [_vm._v(_vm._s(country.total))]
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ])
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "w-3/4 md:w-2/3 p-3 " }, [
        _c("div", { staticClass: "mb-2 bg-white" }, [
          _c(
            "div",
            {
              staticClass:
                "card cursor-pointer border border-gray-400 rounded-lg"
            },
            [
              _c(
                "div",
                { staticClass: "m-3" },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("highcharts", {
                    ref: "chart",
                    staticClass: "hc h-300",
                    attrs: { options: _vm.dataWeeklySubscriber }
                  })
                ],
                1
              )
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "flex flex-wrap" }, [
      _c("div", { staticClass: "w-3/4 md:w-2/3 p-3" }, [
        _c("div", { staticClass: "mb-2 bg-white" }, [
          _c(
            "div",
            {
              staticClass:
                "card cursor-pointer border border-gray-400 rounded-lg"
            },
            [
              _c(
                "div",
                { staticClass: "m-3" },
                [
                  _c(
                    "h2",
                    {
                      staticClass:
                        "text-xs text-left font-bold mb-2 border-b border-black mb-3"
                    },
                    [
                      _vm._v(
                        "Number Songs Sold " +
                          _vm._s(new Date().getFullYear()) +
                          "\n                  "
                      ),
                      _c("span", {
                        staticClass: "text-xs text-teal-800 float-right"
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("highcharts", {
                    ref: "chart2",
                    staticClass: "hc2 h-300",
                    attrs: { options: _vm.soldSong }
                  })
                ],
                1
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "w-1/4 md:w-1/3  p-3" }, [
        _c("div", { staticClass: "mb-2 bg-white" }, [
          _c(
            "div",
            {
              staticClass:
                "card cursor-pointer border border-gray-400 rounded-lg hover:shadow-md hover:border-opacity-0 transform hover:-translate-y-1 transition-all duration-200"
            },
            [
              _c("div", { staticClass: "m-3" }, [
                _c(
                  "h2",
                  {
                    staticClass:
                      "text-xs text-left font-bold border-b border-black"
                  },
                  [_vm._v("Most Popular Song")]
                ),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    staticClass: "flex mb-0 list-none flex-wrap pb-4 flex-row"
                  },
                  [
                    _c(
                      "li",
                      {
                        staticClass:
                          "-mb-px flex-auto text-center cursor-pointer "
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass:
                              " text-xs uppercase px-5 py-3  block leading-normal text-black",
                            class: {
                              "": _vm.popularSongTabIndex !== 1,
                              "font-bold border-b border-black":
                                _vm.popularSongTabIndex === 1
                            },
                            on: {
                              click: function($event) {
                                return _vm.toggleTabPopularSong(1)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                      Lifetime\n                    "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass:
                          "-mb-px flex-auto text-center cursor-pointer "
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass:
                              "text-xs uppercase px-5 py-3 block leading-normal text-black",
                            class: {
                              "": _vm.popularSongTabIndex !== 2,
                              "font-bold border-b border-black":
                                _vm.popularSongTabIndex === 2
                            },
                            on: {
                              click: function($event) {
                                return _vm.toggleTabPopularSong(2)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                      Current\n                    "
                            )
                          ]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "relative flex flex-col min-w-0 break-words bg-white w-full mb-2 overflow-y-auto",
                    staticStyle: { height: "274px" }
                  },
                  [
                    _c("div", { staticClass: "flex-auto" }, [
                      _c("div", { staticClass: "tab-content tab-space px-1" }, [
                        _c(
                          "div",
                          {
                            staticClass: "mx-400 overflow-y-auto",
                            class: {
                              hidden: _vm.popularSongTabIndex !== 1,
                              block: _vm.popularSongTabIndex === 1
                            }
                          },
                          [
                            _c(
                              "ol",
                              {
                                staticClass: "list-outside pl-6",
                                class:
                                  _vm.dataPopularSongLifetime.length > 0
                                    ? "list-decimal"
                                    : ""
                              },
                              [
                                _vm.dataPopularSongLifetime.length === 0
                                  ? _c(
                                      "li",
                                      {
                                        staticClass:
                                          "text-center text-sm font-bold text-black p-3"
                                      },
                                      [_vm._v("No Data")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(_vm.dataPopularSongLifetime, function(
                                  song
                                ) {
                                  return _c(
                                    "li",
                                    {
                                      key: song.id,
                                      staticClass:
                                        "text-left text-sm font-bold text-black mb-3"
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(song.name)
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text-xs text-teal-800 float-right"
                                        },
                                        [_vm._v(_vm._s(song.total_purchase))]
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "mx-400 overflow-y-auto",
                            class: {
                              hidden: _vm.popularSongTabIndex !== 2,
                              block: _vm.popularSongTabIndex === 2
                            }
                          },
                          [
                            _c(
                              "ol",
                              {
                                staticClass: "list-outside pl-6",
                                class:
                                  _vm.dataPopularSongCurrent.length > 0
                                    ? "list-decimal"
                                    : ""
                              },
                              [
                                _vm.dataPopularSongCurrent.length === 0
                                  ? _c(
                                      "li",
                                      {
                                        staticClass:
                                          "text-center text-sm font-bold text-black p-3"
                                      },
                                      [_vm._v("No Data")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(_vm.dataPopularSongCurrent, function(
                                  song
                                ) {
                                  return _c(
                                    "li",
                                    {
                                      key: song.id,
                                      staticClass:
                                        "text-left text-sm font-bold text-black mb-3"
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(song.name)
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text-xs text-teal-800 float-right"
                                        },
                                        [_vm._v(_vm._s(song.total_purchase))]
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          ]
                        )
                      ])
                    ])
                  ]
                )
              ])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "flex flex-wrap" }, [
      _c("div", { staticClass: "w-1/4 md:w-1/3 p-3" }, [
        _c("div", { staticClass: "mb-2 bg-white" }, [
          _c(
            "div",
            {
              staticClass:
                "card cursor-pointer border border-gray-400 rounded-lg hover:shadow-md hover:border-opacity-0 transform hover:-translate-y-1 transition-all duration-200"
            },
            [
              _c("div", { staticClass: "m-3" }, [
                _c(
                  "h2",
                  {
                    staticClass:
                      "text-xs text-left font-bold border-b border-black"
                  },
                  [_vm._v("Most Popular Album")]
                ),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    staticClass: "flex mb-0 list-none flex-wrap pb-4 flex-row"
                  },
                  [
                    _c(
                      "li",
                      {
                        staticClass:
                          "-mb-px flex-auto text-center cursor-pointer "
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass:
                              " text-xs uppercase px-5 py-3  block leading-normal text-black",
                            class: {
                              "": _vm.popularAlbumTabIndex !== 1,
                              "font-bold border-b border-black":
                                _vm.popularAlbumTabIndex === 1
                            },
                            on: {
                              click: function($event) {
                                return _vm.toggleTabPopularAlbum(1)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                      Lifetime\n                    "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass:
                          "-mb-px flex-auto text-center cursor-pointer "
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass:
                              "text-xs uppercase px-5 py-3 block leading-normal text-black",
                            class: {
                              "": _vm.popularAlbumTabIndex !== 2,
                              "font-bold border-b border-black":
                                _vm.popularAlbumTabIndex === 2
                            },
                            on: {
                              click: function($event) {
                                return _vm.toggleTabPopularAlbum(2)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                      Active year\n                    "
                            )
                          ]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "relative flex flex-col min-w-0 break-words bg-white w-full mb-2 overflow-y-auto",
                    staticStyle: { height: "274px" }
                  },
                  [
                    _c("div", { staticClass: "flex-auto" }, [
                      _c("div", { staticClass: "tab-content tab-space px-1" }, [
                        _c(
                          "div",
                          {
                            staticClass: "mx-400 overflow-y-auto",
                            class: {
                              hidden: _vm.popularAlbumTabIndex !== 1,
                              block: _vm.popularAlbumTabIndex === 1
                            }
                          },
                          [
                            _c(
                              "ol",
                              {
                                staticClass: "list-outside pl-6",
                                class:
                                  _vm.dataPopularAlbumLifetime.length > 0
                                    ? "list-decimal"
                                    : ""
                              },
                              [
                                _vm.dataPopularAlbumLifetime.length === 0
                                  ? _c(
                                      "li",
                                      {
                                        staticClass:
                                          "text-center text-sm font-bold text-black p-3"
                                      },
                                      [_vm._v("No Data")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(_vm.dataPopularAlbumLifetime, function(
                                  song
                                ) {
                                  return _c(
                                    "li",
                                    {
                                      key: song.id,
                                      staticClass:
                                        "text-left text-sm font-bold text-black mb-3"
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(song.name)
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text-xs text-teal-800 float-right"
                                        },
                                        [_vm._v(_vm._s(song.total_purchase))]
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "mx-400 overflow-y-auto",
                            class: {
                              hidden: _vm.popularAlbumTabIndex !== 2,
                              block: _vm.popularAlbumTabIndex === 2
                            }
                          },
                          [
                            _c(
                              "ol",
                              {
                                staticClass: "list-outside pl-6",
                                class:
                                  _vm.dataPopularAlbumCurrent.length > 0
                                    ? "list-decimal"
                                    : ""
                              },
                              [
                                _vm.dataPopularAlbumCurrent.length === 0
                                  ? _c(
                                      "li",
                                      {
                                        staticClass:
                                          "text-center text-sm font-bold text-black p-3"
                                      },
                                      [_vm._v("No Data")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(_vm.dataPopularAlbumCurrent, function(
                                  song
                                ) {
                                  return _c(
                                    "li",
                                    {
                                      key: song.id,
                                      staticClass:
                                        "text-left text-sm font-bold text-black mb-3"
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(song.name)
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text-xs text-teal-800 float-right"
                                        },
                                        [_vm._v(_vm._s(song.total_purchase))]
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          ]
                        )
                      ])
                    ])
                  ]
                )
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "w-3/4 md:w-2/3 p-3" }, [
        _c("div", { staticClass: "mb-2 bg-white" }, [
          _c(
            "div",
            {
              staticClass:
                "card cursor-pointer border border-gray-400 rounded-lg hover:shadow-md hover:border-opacity-0 transform hover:-translate-y-1 transition-all duration-200"
            },
            [
              _c("div", { staticClass: "m-3" }, [
                _c(
                  "h2",
                  {
                    staticClass:
                      "text-xs text-left font-bold mb-2 border-b border-black mb-3"
                  },
                  [_vm._v("Highest Earning Artist")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "h-300 overflow-y-auto" }, [
                  _c("table", { staticClass: "border table-auto w-full" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      { staticClass: "text-black text-xs font-light" },
                      [
                        _vm._l(_vm.dataTopEarningArtist, function(artist) {
                          return _c(
                            "tr",
                            {
                              key: artist.id,
                              staticClass:
                                "border-b border-gray-200 hover:bg-gray-100"
                            },
                            [
                              _c("td", { staticClass: "py-3 px-6 text-left" }, [
                                _vm._v(_vm._s(artist.name))
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "py-3 px-6 text-left" }, [
                                _vm._v(_vm._s(artist.total_album))
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "py-3 px-6 text-left" }, [
                                _vm._v(_vm._s(artist.total_song))
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "py-3 px-6 text-left" }, [
                                _vm._v(_vm._s(artist.total_song_sold))
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "py-3 px-6 text-left" }, [
                                _vm._v(
                                  "$" +
                                    _vm._s(
                                      !!artist.earning
                                        ? parseFloat(artist.earning).toFixed(2)
                                        : 0
                                    )
                                )
                              ])
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _vm.dataTopEarningArtist.length === 0
                          ? _c(
                              "tr",
                              {
                                staticClass:
                                  "border-b border-gray-200 hover:bg-gray-100"
                              },
                              [
                                _c(
                                  "td",
                                  {
                                    staticClass: "py-3 px-6 text-center",
                                    attrs: { colspan: "4" }
                                  },
                                  [_vm._v("No Data")]
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      2
                    )
                  ])
                ])
              ])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "flex flex-wrap" }, [
      _c("div", { staticClass: "w-1/4 md:w-1/3 p-3" }, [
        _c("div", { staticClass: "mb-2 bg-white" }, [
          _c(
            "div",
            {
              staticClass:
                "card cursor-pointer border border-gray-400 rounded-lg hover:shadow-md hover:border-opacity-0 transform hover:-translate-y-1 transition-all duration-200"
            },
            [
              _c("div", { staticClass: "m-3" }, [
                _c(
                  "h2",
                  {
                    staticClass:
                      "text-xs text-left font-bold border-b border-black"
                  },
                  [_vm._v("Most Popular Album By Play")]
                ),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    staticClass: "flex mb-0 list-none flex-wrap pb-4 flex-row"
                  },
                  [
                    _c(
                      "li",
                      {
                        staticClass:
                          "-mb-px flex-auto text-center cursor-pointer "
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass:
                              " text-xs uppercase px-5 py-3  block leading-normal text-black",
                            class: {
                              "": _vm.popularAlbumByPlayTabIndex !== 1,
                              "font-bold border-b border-black":
                                _vm.popularAlbumByPlayTabIndex === 1
                            },
                            on: {
                              click: function($event) {
                                return _vm.toggleTabPopularAlbumByPlay(1)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                      Lifetime\n                    "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass:
                          "-mb-px flex-auto text-center cursor-pointer "
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass:
                              "text-xs uppercase px-5 py-3 block leading-normal text-black",
                            class: {
                              "": _vm.popularAlbumByPlayTabIndex !== 2,
                              "font-bold border-b border-black":
                                _vm.popularAlbumByPlayTabIndex === 2
                            },
                            on: {
                              click: function($event) {
                                return _vm.toggleTabPopularAlbumByPlay(2)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                      Active year\n                    "
                            )
                          ]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "relative flex flex-col min-w-0 break-words bg-white w-full mb-2 overflow-y-auto",
                    staticStyle: { height: "274px" }
                  },
                  [
                    _c("div", { staticClass: "flex-auto" }, [
                      _c("div", { staticClass: "tab-content tab-space px-1" }, [
                        _c(
                          "div",
                          {
                            staticClass: "mx-400 overflow-y-auto",
                            class: {
                              hidden: _vm.popularAlbumByPlayTabIndex !== 1,
                              block: _vm.popularAlbumByPlayTabIndex === 1
                            }
                          },
                          [
                            _c(
                              "ol",
                              {
                                staticClass: "list-outside pl-6",
                                class:
                                  _vm.dataPopularAlbumByPlayLifetime.length > 0
                                    ? "list-decimal"
                                    : ""
                              },
                              [
                                _vm.dataPopularAlbumByPlayLifetime.length === 0
                                  ? _c(
                                      "li",
                                      {
                                        staticClass:
                                          "text-center text-sm font-bold text-black p-3"
                                      },
                                      [_vm._v("No Data")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.dataPopularAlbumByPlayLifetime,
                                  function(song) {
                                    return _c(
                                      "li",
                                      {
                                        key: song.album_id,
                                        staticClass:
                                          "text-left text-sm font-bold text-black mb-3"
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(song.name)
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-xs text-teal-800 float-right"
                                          },
                                          [_vm._v(_vm._s(song.play_count))]
                                        )
                                      ]
                                    )
                                  }
                                )
                              ],
                              2
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "mx-400 overflow-y-auto",
                            class: {
                              hidden: _vm.popularAlbumByPlayTabIndex !== 2,
                              block: _vm.popularAlbumByPlayTabIndex === 2
                            }
                          },
                          [
                            _c(
                              "ol",
                              {
                                staticClass: "list-outside pl-6",
                                class:
                                  _vm.dataPopularAlbumByPlayCurrent.length > 0
                                    ? "list-decimal"
                                    : ""
                              },
                              [
                                _vm.dataPopularAlbumByPlayCurrent.length === 0
                                  ? _c(
                                      "li",
                                      {
                                        staticClass:
                                          "text-center text-sm font-bold text-black p-3"
                                      },
                                      [_vm._v("No Data")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.dataPopularAlbumByPlayCurrent,
                                  function(song) {
                                    return _c(
                                      "li",
                                      {
                                        key: song.album_id,
                                        staticClass:
                                          "text-left text-sm font-bold text-black mb-3"
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(song.name)
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-xs text-teal-800 float-right"
                                          },
                                          [_vm._v(_vm._s(song.play_count))]
                                        )
                                      ]
                                    )
                                  }
                                )
                              ],
                              2
                            )
                          ]
                        )
                      ])
                    ])
                  ]
                )
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "w-1/4 md:w-1/3 p-3" }, [
        _c("div", { staticClass: "mb-2 bg-white" }, [
          _c(
            "div",
            {
              staticClass:
                "card cursor-pointer border border-gray-400 rounded-lg hover:shadow-md hover:border-opacity-0 transform hover:-translate-y-1 transition-all duration-200"
            },
            [
              _c("div", { staticClass: "m-3" }, [
                _c(
                  "h2",
                  {
                    staticClass:
                      "text-xs text-left font-bold border-b border-black"
                  },
                  [_vm._v("Most Popular Song By Play")]
                ),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    staticClass: "flex mb-0 list-none flex-wrap pb-4 flex-row"
                  },
                  [
                    _c(
                      "li",
                      {
                        staticClass:
                          "-mb-px flex-auto text-center cursor-pointer "
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass:
                              " text-xs uppercase px-5 py-3  block leading-normal text-black",
                            class: {
                              "": _vm.popularSongByPlayTabIndex !== 1,
                              "font-bold border-b border-black":
                                _vm.popularSongByPlayTabIndex === 1
                            },
                            on: {
                              click: function($event) {
                                return _vm.toggleTabPopularSongByPlay(1)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                      Lifetime\n                    "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass:
                          "-mb-px flex-auto text-center cursor-pointer "
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass:
                              "text-xs uppercase px-5 py-3 block leading-normal text-black",
                            class: {
                              "": _vm.popularSongByPlayTabIndex !== 2,
                              "font-bold border-b border-black":
                                _vm.popularSongByPlayTabIndex === 2
                            },
                            on: {
                              click: function($event) {
                                return _vm.toggleTabPopularSongByPlay(2)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                      Active year\n                    "
                            )
                          ]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "relative flex flex-col min-w-0 break-words bg-white w-full mb-2 overflow-y-auto",
                    staticStyle: { height: "274px" }
                  },
                  [
                    _c("div", { staticClass: "flex-auto" }, [
                      _c("div", { staticClass: "tab-content tab-space px-1" }, [
                        _c(
                          "div",
                          {
                            staticClass: "mx-400 overflow-y-auto",
                            class: {
                              hidden: _vm.popularSongByPlayTabIndex !== 1,
                              block: _vm.popularSongByPlayTabIndex === 1
                            }
                          },
                          [
                            _c(
                              "ol",
                              {
                                staticClass: "list-outside pl-6",
                                class:
                                  _vm.dataPopularSongByPlayLifetime.length > 0
                                    ? "list-decimal"
                                    : ""
                              },
                              [
                                _vm.dataPopularSongByPlayLifetime.length === 0
                                  ? _c(
                                      "li",
                                      {
                                        staticClass:
                                          "text-center text-sm font-bold text-black p-3"
                                      },
                                      [_vm._v("No Data")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.dataPopularSongByPlayLifetime,
                                  function(song) {
                                    return _c(
                                      "li",
                                      {
                                        key: song.id,
                                        staticClass:
                                          "text-left text-sm font-bold text-black mb-3"
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(song.title)
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-xs text-teal-800 float-right"
                                          },
                                          [_vm._v(_vm._s(song.play_count))]
                                        )
                                      ]
                                    )
                                  }
                                )
                              ],
                              2
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "mx-400 overflow-y-auto",
                            class: {
                              hidden: _vm.popularSongByPlayTabIndex !== 2,
                              block: _vm.popularSongByPlayTabIndex === 2
                            }
                          },
                          [
                            _c(
                              "ol",
                              {
                                staticClass: "list-outside pl-6",
                                class:
                                  _vm.dataPopularSongByPlayCurrent.length > 0
                                    ? "list-decimal"
                                    : ""
                              },
                              [
                                _vm.dataPopularSongByPlayCurrent.length === 0
                                  ? _c(
                                      "li",
                                      {
                                        staticClass:
                                          "text-center text-sm font-bold text-black p-3"
                                      },
                                      [_vm._v("No Data")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.dataPopularSongByPlayCurrent,
                                  function(song) {
                                    return _c(
                                      "li",
                                      {
                                        key: song.id,
                                        staticClass:
                                          "text-left text-sm font-bold text-black mb-3"
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(song.title)
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-xs text-teal-800 float-right"
                                          },
                                          [_vm._v(_vm._s(song.play_count))]
                                        )
                                      ]
                                    )
                                  }
                                )
                              ],
                              2
                            )
                          ]
                        )
                      ])
                    ])
                  ]
                )
              ])
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "h2",
      {
        staticClass:
          "text-xs text-left font-bold mb-2 border-b border-black mb-3"
      },
      [
        _vm._v("Weekly Subscriber\n                  "),
        _c("span", { staticClass: "text-xs text-teal-800 float-right" })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c(
        "tr",
        {
          staticClass:
            "bg-gray-400 text-gray-600 uppercase text-xs leading-normal"
        },
        [
          _c("th", { staticClass: "py-3 px-6 text-left" }, [_vm._v("Artist")]),
          _vm._v(" "),
          _c("th", { staticClass: "py-3 px-6 text-left" }, [
            _vm._v("Album Sold")
          ]),
          _vm._v(" "),
          _c("th", { staticClass: "py-3 px-6 text-left" }, [
            _vm._v("Single Sold")
          ]),
          _vm._v(" "),
          _c("th", { staticClass: "py-3 px-6 text-left" }, [
            _vm._v("Total Song Sold")
          ]),
          _vm._v(" "),
          _c("th", { staticClass: "py-3 px-6 text-left" }, [_vm._v("Earning")])
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b343f0a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b343f0a0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Statistic/Admin.vue
// module id = null
// module chunks = 